import { MarketActivityIndicator } from '@market/react';

const LoadingScreen = ({ transparent }) => {
  return (
    <div
      className={`addons-loading-screen ${
        transparent ? 'addons-loading-screen-transparent' : ''
      }`}
    >
      <MarketActivityIndicator data-testid="addons-loading-indicator" />
    </div>
  );
};

export default LoadingScreen;
